module.exports = __webpack_public_path__ + "7e7c9203.svg";